import React from "react";
import RaiseIncidentPage from "./RaiseIncidentPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface RaiseIncidentPageContainerProps extends RouteProps, withValidUserRoleProps {}

const RaiseIncidentPageContainer = (props: RaiseIncidentPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };
    
    const searchparam = props.location ? new URLSearchParams(props.location.search.toLowerCase()) : null;
    let incidentId: any;
    if (props.location && props.location.search) {
        incidentId = searchparam ? searchparam.get("filterby") : "";
    }
    return <RaiseIncidentPage title={getTitle()} category={getType()} incidentId={incidentId}/>;
};

export default withValidUserRole(RaiseIncidentPageContainer);
